import { createSelector } from 'reselect';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
const getCloneRequestState = basicSelector(state => state.cloneRequest);
export const getActionForCloneRequest = createSelector(getCloneRequestState, cloneRequest => cloneRequest.actionToDispatch);
export const getTypeForCloneRequest = createSelector(getCloneRequestState, cloneRequest => cloneRequest.typeToClone);